const numberFormatValidator = /^\d+$/;
const largeUnitsBase = ['nghìn', 'triệu', 'tỉ'];
const basicNumberToWord = {
    '0': 'không',
    '1': 'một',
    '2': 'hai',
    '3': 'ba',
    '4': 'bốn',
    '5': 'năm',
    '6': 'sáu',
    '7': 'bảy',
    '8': 'tám',
    '9': 'chín'
};
const HUNDRED_PLACE_INDEX = 0;
const TENS_PLACE_INDEX = 1;
const ONES_PLACE_INDEX = 2;

export class NumberToWord {
    static breakIntoGroupOfThree(str: string) {
        const groups: string[] = [];
        const remainder = str.length % 3;

        if (str.length > 3 && remainder !== 0) {
            groups.push(str.substr(0, remainder));
            str = str.substr(remainder);
        }
        return groups.concat(str.match(/\d{1,3}/g) as any);
    }

    static mapGroupsToUnits(groups) {
        const reversedGroups = groups.slice().reverse();

        const reversedUnits = reversedGroups.map((group, index) => {
            if (index === 0) {
                return '';
            }
            return largeUnitsBase[(index - 1) % 3];
        });
        return reversedUnits.reverse();
    }

    static translateThreeDigitsNumberToWords(number) {
        if (number === '000')
            return '';
        number = String(number);

        if (number.length > 3 || number.length < 0 || !numberFormatValidator.test(number)) {
            throw TypeError;
        }
        const digitsLength = number.length;

        return number.split('').map((digit, numberIndex) => {
            let placeIndex = numberIndex;

            if (digitsLength < 3) {
                placeIndex = placeIndex + (3 - digitsLength);
            }
            switch (placeIndex) {
                case HUNDRED_PLACE_INDEX: {
                    return basicNumberToWord[digit] + ' trăm';
                }
                case TENS_PLACE_INDEX: {
                    if (digit === '0') {
                        const nextDigest = number[numberIndex + 1];

                        if (nextDigest === '0') {
                            return '';
                        }

                        return 'lẻ';
                    }
                    if (digit === '1') {
                        return 'mười';
                    }
                    return basicNumberToWord[digit] + ' mươi';
                }
                case ONES_PLACE_INDEX: {
                    if (digit === '5' && digitsLength > 1) {
                        return 'lăm';
                    }
                    if (digit === '1' && digitsLength > 1) {
                        const nextDigest = number[numberIndex - 1];

                        if (nextDigest !== '0') {
                            return 'mốt';
                        }
                    }
                    if (digit === '0' && digitsLength > 1) {
                        return '';
                    }
                    return basicNumberToWord[digit];
                }
            }
            return null;
        }).filter(n => n !== '').join(' ');
    }

    static mapGroupsToWords(groups) {
        return groups.map((number) => {
            return this.translateThreeDigitsNumberToWords(number);
        });
    }

    getFullText(numberOrString) {
        const number = String(numberOrString);
        const groups = NumberToWord.breakIntoGroupOfThree(number);
        const groupsToUnits = NumberToWord.mapGroupsToUnits(groups);
        const groupsToWords = NumberToWord.mapGroupsToWords(groups);

        const a = groupsToWords.filter(w => w !== '').map((word, index) => {
            if (groupsToUnits[index] === '') {
                return word;
            }
            return word + ' ' + groupsToUnits[index];
        }).join(' ');
        return this.capitalizeFirstLetter(a);
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

}

export const numberToWord = new NumberToWord();
